import { GlobeAltIcon, PaperClipIcon } from "@heroicons/react/24/solid";
import clsx from "clsx";
import md5 from "crypto-js/md5";
import { colorsList, colorsMap400 } from "../../colors-list";
import styles from "./index.module.css";

type Props = {
  title: string;
};

export const getColorForExtension = (input: string) => {
  const inputAsNumber = parseInt(md5(input).toString(), 16);

  const colorsListValues = Object.keys(colorsList);

  const randomColor = colorsListValues[inputAsNumber % colorsListValues.length];

  return colorsMap400[randomColor];
};

export default function FileExtension(props: Props) {
  const parts = props.title.split(".");
  const extension = parts.length > 1 ? parts.pop() : undefined;
  const isUrl =
    props.title.startsWith("http") || props.title.startsWith("https");

  return (
    <span
      className={clsx(styles.FileExtensionIcon, "m-1 h-8 w-8 rounded-full")}
      style={{
        background: isUrl ? "#0090FF" : getColorForExtension(extension || ""),
      }}
    >
      {isUrl ? (
        <GlobeAltIcon color="#fff" className="h-6 w-6" />
      ) : extension ? (
        <span>{extension?.slice(0, 4)}</span>
      ) : (
        <PaperClipIcon color="currentColor" className="h-6 w-6" />
      )}
    </span>
  );
}
